import { openModal } from '@core/components/ModalStack';
import { TodoChecklistOverlayProps } from './TodoChecklistOverlay';

export async function openTodoChecklistOverlay(props: TodoChecklistOverlayProps) {
  const { TodoChecklistOverlay } = await import('./TodoChecklistOverlay');

  openModal(TodoChecklistOverlay, props);
}
